import { ILogEntry } from "motw_core/Entity/ILogEntry";
import * as React from "react";
import { StyleClass } from "../../Shared/Styles/CSS";
import LogEntrySymbol from "../Log/LogEntries/LogEntrySymbol/LogEntrySymbol";
import * as styles from "./LogMonumental.css";
import * as classNames from "classnames";
import * as moment from "moment";
import { StyleClassAuto } from "../../Shared/Styles/Auto/StyleClassAuto";
import ReactTooltip from "react-tooltip";

export function LogMonumentalRow({
    logEntry,
    randomLogEntryId,
    allRows,
}: {
    logEntry: ILogEntry;
    randomLogEntryId: number;
    allRows: ILogEntry[];
}) {
    const sharedStyle = StyleClass(`logMonumentalItem_sharedStyle`, {
        background: `rgba(0,0,0,0)`,
        margin: `5px 0px`,
        opacity: 0.8,
        ":hover": { opacity: 1, textShadow: `0px 0px 5px gold` },
        color: `gold`,
    });

    const randomLogEntryStyle = StyleClass(`logMonumentalItem_random`, {
        color: "black",
        fontWeight: "bold",
        fontSize: "22px",
        padding: "3px 5px",
        borderRadius: "2px",
        backgroundImage:
            "linear-gradient( 		135deg, 		#ffc700 25%, 		#ffb81f 25%, 		#ffb81f 50%, 		#ffc700 50%, 		#ffc700 75%, 		#ffb81f 75%, 		#ffb81f 100% 	)",
        backgroundSize: "28.28px 28.28px",
    });

    const shouldDrawBorder = ShouldDrawBorder(logEntry, allRows);

    return (
        <div
            id={`scrollTarget_logMonumental_${logEntry.id}`}
            className={classNames([sharedStyle], {
                [randomLogEntryStyle]: logEntry.id === randomLogEntryId,
                [StyleClassAuto({
                    borderTop: "1px dotted darkgoldenrod",
                    paddingTop: "5px",
                })]: shouldDrawBorder,
            })}
            data-row={logEntry.id}
            key={logEntry.id}
        >
            <div className={styles.row}>
                <LogEntrySymbol
                    entry={logEntry.entry}
                    rowId={logEntry.id}
                    key={logEntry.id}
                />{" "}
                <span
                    className={StyleClassAuto({
                        flex: 1,
                    })}
                >
                    {logEntry.entry.substr(4)}{" "}
                </span>
                <ShowTimeAgo
                    {...{ logEntry, key: logEntry.lastmodifiedtime }}
                />
            </div>
        </div>
    );
}

function ShowTimeAgo({ logEntry }: { logEntry: ILogEntry }) {
    const logEntryMoment = moment(logEntry.lastmodifiedtime);
    const toolTipText = logEntryMoment.format("YYYY-MM-DD");

    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    return (
        <span
            style={{
                width: "75px",
                maxWidth: `15vw`,
                fontSize: "0.7em",
                color: `gray`,
                flex: `0 0 auto`,
            }}
            data-tip={toolTipText}
        >
            {logEntryMoment.local().fromNow()}
        </span>
    );
}

function ShouldDrawBorder(logEntry: ILogEntry, allRows: ILogEntry[]): boolean {
    const currentLogEntryTime = moment(logEntry.lastmodifiedtime);
    const currentLogEntryYear = currentLogEntryTime.year();

    if (logEntry === allRows[0]) {
        return false;
    }

    for (let row of allRows) {
        const rowTime = moment(row.lastmodifiedtime);
        if (
            rowTime.year() === currentLogEntryYear &&
            rowTime.isAfter(currentLogEntryTime)
        ) {
            return false;
        }
    }

    return true;
}
